import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'districtEvent'
})
export class DistrictEventPipe implements PipeTransform {

  transform(events: any[], args?: any): any {
    return events.filter(event => event.meta.eventType == 'districtEvent');
  }

}
